import { render, staticRenderFns } from "./wage.vue?vue&type=template&id=55388afa&scoped=true&"
import script from "./wage.vue?vue&type=script&lang=js&"
export * from "./wage.vue?vue&type=script&lang=js&"
import style0 from "./wage.vue?vue&type=style&index=0&id=55388afa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55388afa",
  null
  
)

export default component.exports